/**
 * @ngdoc controller
 * @module portaro.conversation
 * @name GoToResponseController
 *
 * @requires walker
 *
 * @description
 * Controller for GoToResponse conversation dialog
 */
import type WalkerService from '../../services/walker.service';

export default class GoToResponseController {
    public static controllerName = 'GoToResponseController';

    /*@ngInject*/
    constructor(private walker: WalkerService) {
    }

    /**
     * @ngdoc method
     * @name GoToResponseController#goTo
     *
     * @param {string} url Redirection URL
     *
     * @description
     * Redirects to giver URL address
     */
    public goTo(url: string) {
        this.walker.newPage(url);
    }
}
